import React, { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import Modal from '../Modals/Modal';
import ConfirmationModal from '../Modals/ConfirmationModal';
import toast from 'react-hot-toast';
import '../Modals/SettingsModal.css';
import './JobManagment.css'; // Add this import

const JobManagment = ({ defWorkId, updateProjectsAndJobs, defaultworkspace }) => {
    const [selectedJob, setSelectedJob] = useState('');
    const [newJobName, setNewJobName] = useState('');
    const [user, setUser] = useState('');
    const [userRole, setUserRole] = useState('');
    const [newJobStatus, setNewJobStatus] = useState(1);
    const [newJobDescription, setNewJobDescription] = useState('');
    const [newJobType, setNewJobType] = useState('');
    const [newJobPriority, setNewJobPriority] = useState(null);
    const [newJobStartDate, setNewJobStartDate] = useState('');
    const [newJobEndDate, setNewJobEndDate] = useState('');
    const [newJobActualEndDate, setNewJobActualEndDate] = useState('');
    const [newJobManagerId, setNewJobManagerId] = useState(null);
    const [selectedProject, setSelectedProject] = useState('');
    const [singleSelectedProject, setSingleSelectedProject] = useState('');
    const [bulkSelectedProject, setBulkSelectedProject] = useState('');
    const [isAddJobOpen, setIsAddJobOpen] = useState(false);
    const [isEditJobOpen, setIsEditJobOpen] = useState(false);
    // Add state for confirmation modal
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [jobToActivate, setJobToActivate] = useState(null);
    const [allProjects, setAllProjects] = useState([]);
    const [workspaceUsers, setWorkspaceUsers] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [archivedJobs, setArchivedJobs] = useState([]);
    const [modalProjectError, setModalProjectError] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    const [archivedJobsLoading, setArchivedJobsLoading] = useState(false);
    // Add this to toggle between active and archived views
    const [showArchived, setShowArchived] = useState(false);
    const [activeTab, setActiveTab] = useState('single');
    const [pasteContent, setPasteContent] = useState('');
    const [parsedJobs, setParsedJobs] = useState([]);
    const [errorMessages, setErrorMessages] = useState([]);
    const [editErrorMessages, setEditErrorMessages] = useState([]);
    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isReviewMode, setIsReviewMode] = useState(false);
    const [jobSearchTerm, setJobSearchTerm] = useState('');
    const [singleProjectSearchTerm, setSingleProjectSearchTerm] = useState('');
    const [singleSearchedProjects, setSingleSearchedProjects] = useState([]);
    const [singleProjectLoading, setSingleProjectLoading] = useState(false);
    const [bulkProjectSearchTerm, setBulkProjectSearchTerm] = useState('');
    const [bulkSearchedProjects, setBulkSearchedProjects] = useState([]);
    const [bulkProjectLoading, setBulkProjectLoading] = useState(false);
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [usersLoading, setUsersLoading] = useState(false);
    const [editLoading, setEditLoading] = useState(false);
    const [archivedSearchTerm, setArchivedSearchTerm] = useState('');
    const [activatingJobId, setActivatingJobId] = useState(null);
    
    // New states for project jobs dropdown
    const [projectJobs, setProjectJobs] = useState([]);
    const [showJobDropdown, setShowJobDropdown] = useState(false);
    const [jobNameSearch, setJobNameSearch] = useState('');
    const [loadingProjectJobs, setLoadingProjectJobs] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deletingJob, setDeletingJob] = useState(false);
    const [deleteError, setDeleteError] = useState(null);
    
    // State to store project-job mappings
    const [projectJobMappings, setProjectJobMappings] = useState({});
    
    const errorRef = useRef(null);
    const editErrorRef = useRef(null);
    const tableRef = useRef(null);
    const singleDebounceRef = useRef(null);
    const bulkDebounceRef = useRef(null);
    const modalContentRef = useRef(null);
    const editModalContentRef = useRef(null);
    const archivedContentRef = useRef(null);
    const editTopRef = useRef(null);
    const addTopRef = useRef(null);
    const archivedTopRef = useRef(null);
    
    // Add state for workspace name
    const [workspaceName, setWorkspaceName] = useState(defaultworkspace);
    
    // Add click timer ref to distinguish between single and double click
    const clickTimerRef = useRef(null);
    
    const handleKeyDown = useCallback((event) => {
        if ((event.ctrlKey || event.metaKey) && event.key === 's') {
            event.preventDefault(); 
            if (isAddJobOpen && !isAdding) {
                if (activeTab === 'single' && singleSelectedProject && newJobName.trim()) {
                    handleAddJob();
                } else if (activeTab === 'bulk' && isReviewMode && bulkSelectedProject && parsedJobs.length > 0) {
                    handleAddBulkJobs();
                }
            } else if (isEditJobOpen && !isEditing && newJobName.trim()) {
                handleEditJob();
            }
        }
    }, [isAddJobOpen, isEditJobOpen, activeTab, isAdding, isEditing, singleSelectedProject, newJobName, bulkSelectedProject, isReviewMode, parsedJobs.length]);
    
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);
        
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isAddJobOpen, isEditJobOpen, handleKeyDown]);
    
    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
        setUser(storedUser?.id || '');
        setUserRole((storedUser?.role || '').toLowerCase());
    }, []);
    
    useEffect(() => {
        if(defWorkId && user){
            fetchInitialData();
        }
    }, [defWorkId, defaultworkspace, user]);
    
    useEffect(() => {
        if (isAddJobOpen) {
            setProjectsLoading(true);
            setUsersLoading(true);
            loadAllProjects();
            loadWorkspaceUsers();
            resetFormStates();
            setErrorMessages([]);
        }
    }, [isAddJobOpen]);
    
    useEffect(() => {
        if (isEditJobOpen) {
            setUsersLoading(true);
            loadWorkspaceUsers();
            setEditErrorMessages([]);
        }
    }, [isEditJobOpen]);
    
    useEffect(() => {
        if (isEditJobOpen && selectedJob) {
            setEditLoading(true);
            fetchJobData();
        }
    }, [isEditJobOpen, selectedJob]);
    
    // Fetch archived jobs when switching to archived view
    useEffect(() => {
        if (showArchived) {
            fetchArchivedJobs();
        }
    }, [showArchived, user]);
    
    useEffect(() => {
        if (singleDebounceRef.current) {
            clearTimeout(singleDebounceRef.current);
        }
        if (!singleProjectSearchTerm.trim()) {
            return;
        }
        singleDebounceRef.current = setTimeout(() => {
            loadSearchedProjects(singleProjectSearchTerm, setSingleSearchedProjects, setSingleProjectLoading);
        }, 300);
        return () => {
            if (singleDebounceRef.current) {
                clearTimeout(singleDebounceRef.current);
            }
        };
    }, [singleProjectSearchTerm]);
    
    useEffect(() => {
        if (bulkDebounceRef.current) {
            clearTimeout(bulkDebounceRef.current);
        }
        if (!bulkProjectSearchTerm.trim()) {
            return;
        }
        bulkDebounceRef.current = setTimeout(() => {
            loadSearchedProjects(bulkProjectSearchTerm, setBulkSearchedProjects, setBulkProjectLoading);
        }, 300);
        return () => {
            if (bulkDebounceRef.current) {
                clearTimeout(bulkDebounceRef.current);
            }
        };
    }, [bulkProjectSearchTerm]);
    
    useEffect(() => {
        if (activeTab === 'single') {
            setSelectedProject(singleSelectedProject);
        } else {
            setSelectedProject(bulkSelectedProject);
        }
    }, [activeTab, singleSelectedProject, bulkSelectedProject]);
    
    useEffect(() => {
        if (errorMessages.length > 0 && errorRef.current) {
            errorRef.current.scrollIntoView({ behavior: 'auto' });
        }
    }, [errorMessages]);
    
    useEffect(() => {
        if (editErrorMessages.length > 0 && editErrorRef.current) {
            editErrorRef.current.scrollIntoView({ behavior: 'auto' });
        }
    }, [editErrorMessages]);
    
    useEffect(() => {
        if (isAdding && modalContentRef.current) {
            try { modalContentRef.current.scrollTop = 0; } catch (e) { }
            try {
                const container = modalContentRef.current.closest && modalContentRef.current.closest('.modal-container');
                if (container) container.scrollTop = 0;
            } catch (e) { }
        }
    }, [isAdding]);
    
    useEffect(() => {
        if (isEditing && editModalContentRef.current) {
            try { editModalContentRef.current.scrollTop = 0; } catch (e) { }
            try {
                const container = editModalContentRef.current.closest && editModalContentRef.current.closest('.modal-container');
                if (container) container.scrollTop = 0;
            } catch (e) { }
        }
    }, [isEditing]);
    
    useEffect(() => {
        if (isAddJobOpen && modalContentRef.current) {
            try { modalContentRef.current.scrollTop = 0; } catch (e) { }
            try {
                const container = modalContentRef.current.closest && modalContentRef.current.closest('.modal-container');
                if (container) container.scrollTop = 0;
            } catch (e) { }
        }
    }, [isAddJobOpen]);
    
    useEffect(() => {
        if (isEditJobOpen && editModalContentRef.current) {
            try { editModalContentRef.current.scrollTop = 0; } catch (e) { }
            try {
                const container = editModalContentRef.current.closest && editModalContentRef.current.closest('.modal-container');
                if (container) container.scrollTop = 0;
            } catch (e) { }
        }
    }, [isEditJobOpen]);
    
    // Handle clicks outside job dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showJobDropdown && !event.target.closest('.job-name-search-wrapper')) {
                setShowJobDropdown(false);
            }
        };
        
        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [showJobDropdown]);
    
    // Clean up click timer on unmount
    useEffect(() => {
        return () => {
            if (clickTimerRef.current) {
                clearTimeout(clickTimerRef.current);
            }
        };
    }, []);
  
    const resetFormStates = () => {
        setNewJobName('');
        setNewJobDescription('');
        setNewJobType('');
        setNewJobPriority(null);
        setNewJobStartDate('');
        setNewJobEndDate('');
        setNewJobActualEndDate('');
        setNewJobManagerId(null);
        setNewJobStatus(1);
        setSelectedProject('');
        setSingleSelectedProject('');
        setBulkSelectedProject('');
        setPasteContent('');
        setParsedJobs([]);
        setIsReviewMode(false);
        setActiveTab('single');
        setSingleProjectSearchTerm('');
        setSingleSearchedProjects([]);
        setBulkProjectSearchTerm('');
        setBulkSearchedProjects([]);
        setProjectJobs([]);
        setShowJobDropdown(false);
        setJobNameSearch('');
        setLoadingProjectJobs(false);
        setArchivedSearchTerm('');
    };
    
    const scrollToTopImmediate = () => {
        try {
            if (typeof window !== 'undefined' && window.scrollTo) {
                window.scrollTo({ top: 0, behavior: 'auto' });
            }
        } catch (e) { }
        try { if (document && document.documentElement) document.documentElement.scrollTop = 0; } catch (e) { }
        try { if (document && document.body) document.body.scrollTop = 0; } catch (e) { }
    };
    
    // Function to handle job click (single or double)
    const handleJobClick = (jobId) => {
        // Clear any existing timer
        if (clickTimerRef.current) {
            clearTimeout(clickTimerRef.current);
        }
        
        // Set a timer for single click
        clickTimerRef.current = setTimeout(() => {
            // Single click: just select the job
            setSelectedJob(jobId);
        }, 300); // Delay for double-click detection
    };
    
    // Function to handle job double click
    const handleJobDoubleClick = (jobId) => {
        // Clear the single click timer
        if (clickTimerRef.current) {
            clearTimeout(clickTimerRef.current);
        }
        
        // Double click: select and open edit modal
        setSelectedJob(jobId);
        setIsEditJobOpen(true);
    };
    
    const fetchInitialData = async () => {
        setPageLoading(true);
        try {
            // Fetch projects that user has access to in this workspace
            const projectsRes = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/Project/GetProjectsByUserJobPermission/${user}/${defWorkId}`
            );
            
            if (!projectsRes.ok) throw new Error('Failed to fetch projects');
            
            const projectsData = await projectsRes.json();
            const projects = projectsData.projects || [];
            setAllProjects(projects);
            
            // For each project, fetch jobs that user has access to
            const jobsPromises = projects.map(async (project) => {
                try {
                    const jobsRes = await fetch(
                        `${process.env.REACT_APP_API_BASE_URL}/api/UserJobAuth/GetJobsByUserAndProject/${user}/${project.id}`
                    );
                    
                    if (jobsRes.ok) {
                        const jobsData = await jobsRes.json();
                        return {
                            projectId: project.id,
                            jobs: jobsData.jobs || []
                        };
                    }
                    return {
                        projectId: project.id,
                        jobs: []
                    };
                } catch {
                    return {
                        projectId: project.id,
                        jobs: []
                    };
                }
            });
            
            const jobsResults = await Promise.all(jobsPromises);
            
            // Create a mapping of projectId to jobs
            const projectJobMap = {};
            const allJobs = [];
            
            jobsResults.forEach(result => {
                const formattedJobs = result.jobs.map(job => ({
                    id: job.jobId,
                    name: job.jobName,
                    projectId: result.projectId,
                    friendlyId: job.friendlyId,
                    // Add other properties if needed, default status to 1 (active)
                    status: 1
                }));
                
                projectJobMap[result.projectId] = formattedJobs;
                allJobs.push(...formattedJobs);
            });
            
            setProjectJobMappings(projectJobMap);
            setJobs(allJobs);
            
        } catch {
            toast.error('Failed to load data');
        } finally {
            setPageLoading(false);
        }
    };
    
    const fetchArchivedJobs = async () => {
        if (!user) return;
        
        setArchivedJobsLoading(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/Job/GetMyJobsByStatus?userId=${user}&status=3`
            );
            
            if (response.ok) {
                const data = await response.json();
                // Enhance jobs with project information
                const enhancedJobs = data.jobs.map(job => {
                    const project = allProjects.find(p => p.id === job.projectId);
                    return {
                        ...job,
                        projectName: project?.name || 'Unknown Project',
                        workspaceName: workspaceName,
                        friendlyId: job.friendlyId
                    };
                });
                setArchivedJobs(enhancedJobs);
            } else {
                toast.error('Failed to load archived jobs');
            }
        } catch (error) {
            toast.error('Network error while loading archived jobs');
        } finally {
            setArchivedJobsLoading(false);
        }
    };
            const handleDeleteJob = async () => {
            if (!selectedJob) {
                toast.error("No job selected to delete");
                return;
            }

            setDeletingJob(true);
            setDeleteError(null);

            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Job/DeleteJob/${selectedJob}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                if (!response.ok) {
                    const errorText = await response.text();
                    let errorMsg = "";
                    
                    if (response.status === 500) {
                        errorMsg = "Unable to delete job. This job may contain notes or be referenced elsewhere.";
                    } else if (response.status === 404) {
                        errorMsg = "Job not found. It may have already been deleted.";
                    } else if (response.status === 409) {
                        errorMsg = "Cannot delete job. It is being used by other records.";
                    } else {
                        errorMsg = `Failed to delete job: ${response.status}`;
                    }
                    
                    throw new Error(errorMsg);
                }

                toast.success("Job deleted successfully");
                
                setShowDeleteConfirm(false);
                closeEditModal();
                await fetchInitialData();
                
            } catch (error) {
                console.error("Error deleting job:", error);
                setDeleteError(error.message);
            } finally {
                setDeletingJob(false);
            }
        };
    
    // Updated handleActivateJob to use confirmation modal
    const handleActivateClick = (job) => {
        setJobToActivate(job);
        setIsConfirmModalOpen(true);
    };
    
    const handleConfirmActivate = async () => {
        if (!jobToActivate) return;
        
        setIsConfirmModalOpen(false);
        setActivatingJobId(jobToActivate.id);
        
        try {
            // Prepare the update payload
            const updatePayload = {
                name: jobToActivate.name,
                description: jobToActivate.description || '',
                status: 1, // Set to Active
                type: jobToActivate.type || null,
                jobPriority: jobToActivate.jobPriority !== null ? jobToActivate.jobPriority : null,
                startDate: jobToActivate.startDate || null,
                endDate: jobToActivate.endDate || null,
                actualEndDate: jobToActivate.actualEndDate || null,
                managerId: jobToActivate.managerId !== null ? jobToActivate.managerId : null,
                createdDate: jobToActivate.createdDate || new Date().toISOString()
            };
            
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/Job/UpdateJob/${jobToActivate.id}`,
                {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updatePayload)
                }
            );
            
            if (!response.ok) {
                throw new Error('Failed to activate job');
            }
            
            toast.success('Job activated successfully');
            
            // Refresh both job lists
            await fetchInitialData();
            await fetchArchivedJobs();
            
        } catch (error) {
            toast.error('Failed to activate job');
        } finally {
            setActivatingJobId(null);
            setJobToActivate(null);
        }
    };
    
    const handleCancelActivate = () => {
        setIsConfirmModalOpen(false);
        setJobToActivate(null);
    };
    
    const loadAllProjects = async () => {
        setModalProjectError(false);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/Project/GetProjectsByUserJobPermission/${user}/${defWorkId}`
            );
            if (res.ok) {
                const data = await res.json();
                setAllProjects(data.projects || []);
            } else {
                throw new Error();
            }
        } catch {
            setModalProjectError(true);
            toast.error('Failed to load projects');
        } finally {
            setProjectsLoading(false);
        }
    };
    
    const loadWorkspaceUsers = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/UserWorkspace/GetUsersByWorkspaceId/${defWorkId}`);
            if (res.ok) {
                const data = await res.json();
                setWorkspaceUsers(data.users || []);
            } else {
                throw new Error();
            }
        } catch {
            toast.error('Failed to load users');
        } finally {
            setUsersLoading(false);
        }
    };
    
    const fetchJobData = async () => {
        setEditLoading(true);
        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Job/GetJobById/${selectedJob}`);
            if (!res.ok) throw new Error();
            const data = await res.json();
            const job = data.job;
            setNewJobName(job.name || '');
            setNewJobDescription(job.description || '');
            setNewJobStatus(job.status || 1);
            setNewJobType(job.type || '');
            setNewJobPriority(job.jobPriority ?? null);
            setNewJobStartDate(job.startDate ? new Date(job.startDate).toISOString().split('T')[0] : '');
            setNewJobEndDate(job.endDate ? new Date(job.endDate).toISOString().split('T')[0] : '');
            setNewJobActualEndDate(job.actualEndDate ? new Date(job.actualEndDate).toISOString().split('T')[0] : '');
            setNewJobManagerId(job.managerId ?? null);
            setSelectedProject(job.projectId || '');
        } catch {
            toast.error('Failed to load job data');
        } finally {
            setEditLoading(false);
        }
    };
    
    const loadSearchedProjects = async (search = '', setSearched, setLoading) => {
        if (!search.trim()) {
            setSearched([]);
            return;
        }
        setLoading(true);
        setModalProjectError(false);
        try {
            const params = new URLSearchParams();
            params.append('q', search);
            params.append('userId', user);
            if (defWorkId) params.append('workspaceId', defWorkId);
            const url = `${process.env.REACT_APP_API_BASE_URL}/api/SiteNote/SearchProjects?${params.toString()}`;
            const res = await fetch(url);
            if (res.ok) {
                const jsonData = await res.json();
                const rawData = jsonData.results || [];
                const normalizedProjects = rawData.map(p => ({
                    id: p.projectId,
                    name: p.projectName,
                    workspaceId: p.workspaceId,
                    status: 1,
                    fullPath: p.fullPath
                }));
                const uniqueProjects = Array.from(new Map(normalizedProjects.map(p => [p.id, p])).values());
                setSearched(uniqueProjects);
            } else {
                throw new Error();
            }
        } catch {
            setModalProjectError(true);
            toast.error('Failed to load projects');
        } finally {
            setLoading(false);
        }
    };
    
    // Function to fetch jobs for selected project
    const fetchProjectJobs = async (projectId) => {
        if (!projectId || !user) return;
        setLoadingProjectJobs(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/UserJobAuth/GetJobsByUserAndProject/${user}/${projectId}`
            );
            if (response.ok) {
                const data = await response.json();
                setProjectJobs(data.jobs || []);
            } else {
                setProjectJobs([]);
            }
        } catch {
            setProjectJobs([]);
            toast.error('Failed to load project jobs');
        } finally {
            setLoadingProjectJobs(false);
        }
    };
    
    const handleAddJob = async () => {
        if (!isAdding) {
            setIsAdding(true);
            if (addTopRef.current) {
                addTopRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }
        setErrorMessages([]);
        try {
            const bodyData = {
                name: newJobName.trim(),
                description: newJobDescription.trim(),
                status: newJobStatus,
                projectId: singleSelectedProject,
                userId: user
            };
            if (newJobType.trim()) {
                bodyData.type = newJobType.trim();
            }
            if (newJobPriority !== null) {
                bodyData.jobPriority = newJobPriority;
            }
            if (newJobStartDate) {
                bodyData.startDate = new Date(newJobStartDate).toISOString();
            }
            if (newJobEndDate) {
                bodyData.endDate = new Date(newJobEndDate).toISOString();
            }
            if (newJobActualEndDate) {
                bodyData.actualEndDate = new Date(newJobActualEndDate).toISOString();
            }
            if (newJobManagerId !== null) {
                bodyData.managerId = newJobManagerId;
            }
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Job/AddJob`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                let errors = [];
                if (Array.isArray(errorData.errors)) errors = errorData.errors;
                else if (errorData.errors && typeof errorData.errors === 'object') {
                    Object.values(errorData.errors).flat().forEach(msg => errors.push(msg));
                } else if (errorData.message) errors = [errorData.message];
                setErrorMessages(errors);
                if (errorRef.current) {
                    errorRef.current.scrollIntoView({ behavior: 'auto' });
                }
                return;
            }
            const data = await response.json();
            toast.success('Job saved successfully');
            try {
                await grantJobPermission(data.job.id);
                await fetchInitialData(); // Refresh the data
            } catch {
                toast.error('Failed to refresh data');
            }
            scrollToTopImmediate();
            closeAddModal();
        } catch {
            toast.error('Network error');
        } finally {
            setIsAdding(false);
        }
    };
    
    const handleEditJob = async () => {
        if (!isEditing) {
            setIsEditing(true);
            if (editTopRef.current) {
                editTopRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }
        setEditErrorMessages([]);
        try {
            const bodyData = {
                id: selectedJob,
                name: newJobName.trim(),
                description: newJobDescription.trim(),
                status: newJobStatus
            };
            if (newJobType.trim()) {
                bodyData.type = newJobType.trim();
            }
            if (newJobPriority !== null) {
                bodyData.jobPriority = newJobPriority;
            }
            if (newJobStartDate) {
                bodyData.startDate = new Date(newJobStartDate).toISOString();
            } else {
                bodyData.startDate = null;
            }
            if (newJobEndDate) {
                bodyData.endDate = new Date(newJobEndDate).toISOString();
            } else {
                bodyData.endDate = null;
            }
            if (newJobActualEndDate) {
                bodyData.actualEndDate = new Date(newJobActualEndDate).toISOString();
            } else {
                bodyData.actualEndDate = null;
            }
            if (newJobManagerId !== null) {
                bodyData.managerId = newJobManagerId;
            } else {
                bodyData.managerId = null;
            }
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Job/UpdateJob/${selectedJob}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData)
            });
            if (!response.ok) {
                const errorData = await response.json();
                let errors = [];
                if (Array.isArray(errorData.errors)) errors = errorData.errors;
                else if (errorData.errors && typeof errorData.errors === 'object') {
                    Object.values(errorData.errors).flat().forEach(msg => errors.push(msg));
                } else if (errorData.message) errors = [errorData.message];
                setEditErrorMessages(errors);
                if (editErrorRef.current) {
                    editErrorRef.current.scrollIntoView({ behavior: 'auto' });
                }
                return;
            }
            toast.success('Job updated');
            try {
                await fetchInitialData(); // Refresh the data
            } catch {
                toast.error('Failed to refresh data');
            }
            scrollToTopImmediate();
            closeEditModal();
        } catch {
            toast.error('Network error');
        } finally {
            setIsEditing(false);
        }
    };
    
    const grantJobPermission = async (jobid) => {
        try {
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/UserJobAuth/AddUserJob`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId: user, jobId: jobid, userIDScreen: user })
            });
        } catch { }
    };
    
    const handleAddBulkJobs = async () => {
        if (!isAdding) {
            setIsAdding(true);
            if (addTopRef.current) {
                addTopRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
            }
        }
        setErrorMessages([]);
        if (!bulkSelectedProject || parsedJobs.length === 0) {
            setErrorMessages(['Project and jobs required']);
            setIsAdding(false);
            return;
        }
        const dtos = parsedJobs.map(job => ({
            name: job.name.trim(),
            description: job.description?.trim() || job.name.trim(),
            projectId: parseInt(bulkSelectedProject),
            userId: user
        }));
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/Job/AddJobsBulk`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dtos)
            });
            if (!response.ok) {
                const err = await response.json();
                let errors = [];
                if (Array.isArray(err.errors)) errors = err.errors;
                else if (err.errors) errors = Object.values(err.errors).flat();
                else if (err.message) errors = [err.message];
                setErrorMessages(errors);
                return;
            }
            const data = await response.json();
            toast.success(`${data.jobs.length} jobs added`);
            try {
                const grantPromises = data.jobs.map(job => grantJobPermission(job.id));
                await Promise.all(grantPromises);
                await fetchInitialData(); // Refresh the data
            } catch {
                toast.error('Failed to refresh data');
            }
            scrollToTopImmediate();
            closeAddModal();
        } catch {
            toast.error('Network error');
        } finally {
            setIsAdding(false);
        }
    };
    
    const handlePasteChange = (e) => setPasteContent(e.target.value);
    
    const handleReview = () => {
        const lines = pasteContent.trim().split('\n');
        const newParsed = lines
            .map(line => {
                const [name, description] = line.split('\t').map(str => str.trim());
                if (name) return { name, description: description || '' };
                return null;
            })
            .filter(Boolean);
        setParsedJobs(newParsed);
        setIsReviewMode(true);
    };
    
    const handleEditParsedJob = (index, field, value) => {
        const updated = [...parsedJobs];
        updated[index][field] = value;
        setParsedJobs(updated);
    };
    
    const handleDeleteRow = (index) => {
        setParsedJobs(parsedJobs.filter((_, i) => i !== index));
    };
    
    const handleAddNewRow = () => {
        setParsedJobs([...parsedJobs, { name: '', description: '' }]);
        setTimeout(() => {
            if (tableRef.current) {
                tableRef.current.scrollTop = tableRef.current.scrollHeight;
            }
        }, 0);
    };
    
    const handleClearPaste = () => {
        setPasteContent('');
        setParsedJobs([]);
        setIsReviewMode(false);
    };
    
    const closeAddModal = () => {
        setIsAddJobOpen(false);
        resetFormStates();
        setErrorMessages([]);
        setModalProjectError(false);
        setSingleProjectLoading(false);
        setBulkProjectLoading(false);
    };
    
    const closeEditModal = () => {
        setIsEditJobOpen(false);
        resetFormStates();
        setEditErrorMessages([]);
    };
    
    const handleSingleSearchChange = (e) => {
        const newTerm = e.target.value;
        setSingleSearchedProjects([]);
        setSingleProjectLoading(!!newTerm.trim());
        setSingleProjectSearchTerm(newTerm);
    };
    
    const handleBulkSearchChange = (e) => {
        const newTerm = e.target.value;
        setBulkSearchedProjects([]);
        setBulkProjectLoading(!!newTerm.trim());
        setBulkProjectSearchTerm(newTerm);
    };
    
    const isAdmin = userRole === 'admin';
    
    // Updated: Now allProjects are already filtered by workspace and user permission
    const activeProjects = useMemo(() => {
        // Assuming all projects returned are active (since they come from permission-based endpoint)
        return allProjects;
    }, [allProjects]);
    
    // Modified filteredJobs to use the jobs we already fetched
    const filteredJobs = useMemo(() => {
        const searchLower = jobSearchTerm.toLowerCase().trim();
        return jobs
            .filter(job => {
                // Find the project for this job
                const project = allProjects.find(p => p.id === job.projectId);
                if (!project) return false;
                
                // Check if job name or project name matches search
                return job.name.toLowerCase().includes(searchLower) || 
                       project.name.toLowerCase().includes(searchLower) ||
                       workspaceName.toLowerCase().includes(searchLower);
            })
            .map(job => {
                const project = allProjects.find(p => p.id === job.projectId);
                return {
                    ...job,
                    projectName: project?.name || 'Unknown Project',
                    workspaceName: workspaceName
                };
            });
    }, [jobs, allProjects, jobSearchTerm, workspaceName]);
    
    // Filtered archived jobs
    const filteredArchivedJobs = useMemo(() => {
        const searchLower = archivedSearchTerm.toLowerCase().trim();
        return archivedJobs.filter(job => {
            return job.name.toLowerCase().includes(searchLower) || 
                   (job.projectName && job.projectName.toLowerCase().includes(searchLower)) ||
                   workspaceName.toLowerCase().includes(searchLower);
        });
    }, [archivedJobs, archivedSearchTerm, workspaceName]);
    
    return (
        <div className="settings-content" style={{ position: 'relative', minHeight: '400px' }}>
            
            {/* Confirmation Modal */}
            <ConfirmationModal
                isOpen={isConfirmModalOpen}
                onClose={handleCancelActivate}
                onConfirm={handleConfirmActivate}
                title="Activate Job"
                message={`Are you sure you want to activate "${jobToActivate?.name}"?`}
                confirmText="Activate"
                cancelText="Cancel"
            />
            
            {pageLoading && (
                <div className="full-overlay">
                    <div className="spinner" />
                    <p style={{fontSize:'1.2rem',fontWeight:'600',margin:0}}>Loading...</p>
                </div>
            )}
            {!pageLoading && (
                <>
                    <div className="settings-action-buttons">
                        <button className="btn-primary" onClick={() => setIsAddJobOpen(true)}>
                            Add Job
                        </button>
                        {/* Add Archived Jobs button right next to Add Job */}
                        <button 
                            className={`btn ${showArchived ? 'btn-primary' : 'btn-secondary'}`} 
                            onClick={() => setShowArchived(!showArchived)}
                        >
                            {showArchived ? 'Show Active Jobs' : 'Archived Jobs'}
                        </button>
                    </div>
                    
                    {/* Show either Active Jobs or Archived Jobs based on state */}
                    {!showArchived ? (
                        /* Active Jobs View */
                        <div className="settings-lookup-list">
                            <h4>Job Lookups</h4>
                            {jobs.length === 0 ? (
                                <div style={{textAlign:'center',padding:'50px',color:'#888'}}>
                                    No jobs found
                                </div>
                            ) : (
                                <div className="search-wrapper">
                                    <input
                                        type="text"
                                        value={jobSearchTerm}
                                        onChange={(e) => setJobSearchTerm(e.target.value)}
                                        placeholder="Search by workspace, project, or job name..."
                                        style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                                    />
                                    {jobSearchTerm.trim() && filteredJobs.length === 0 && (
                                        <div className="dropdown-message error-box">
                                            No jobs match your search
                                        </div>
                                    )}
                                    {!jobSearchTerm.trim() && filteredJobs.length === 0 && (
                                        <div className="error-box">
                                            No jobs available
                                        </div>
                                    )}
                                    {filteredJobs.length > 0 && (
                                        <ul className="project-search-list">
                                            {filteredJobs.map(job => {
                                                const isInactive = job.status !== 1;
                                                return (
                                                    <li
                                                        key={job.id}
                                                        className={`double-clickable ${selectedJob === job.id ? 'selected' : ''}`}
                                                        onClick={() => handleJobClick(job.id)}
                                                        onDoubleClick={() => handleJobDoubleClick(job.id)}
                                                        style={{ cursor: 'pointer' }}
                                                        title="Click to select, double-click to edit"
                                                    >
                                                        <div className="job-path">
                                                            <span className="workspace-name">{job.workspaceName}</span>
                                                            <span className="path-separator">→</span>
                                                            <span className="workspace-name">{job.projectName}</span>
                                                            <span className="path-separator">→</span>
                                                            <span className="job-name">{job.name}</span>
                                                        </div>
                                                        {isInactive && (
                                                            <span className={`job-status-badge ${
                                                                job.status === 2 ? 'status-inactive' : 'status-archive'
                                                            }`}>
                                                                {job.status === 2 ? 'Inactive' : 'Archived'}
                                                            </span>
                                                        )}
                                                        {!isInactive && job.status === 1 && (
                                                            <span className="job-status-badge status-active">
                                                                Active
                                                            </span>
                                                        )}
                                                        <button 
                                                            className="delete-job-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation(); 
                                                                setSelectedJob(job.id);
                                                                setNewJobName(job.name);
                                                                setShowDeleteConfirm(true);
                                                            }}
                                                            title="Delete job"
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    ) : (
                        /* Archived Jobs View */
                        <div className="settings-lookup-list" ref={archivedContentRef}>
                            <h4>Archived Jobs</h4>
                            <div className="search-wrapper" style={{ marginBottom: '20px' }}>
                                <input
                                    type="text"
                                    value={archivedSearchTerm}
                                    onChange={(e) => setArchivedSearchTerm(e.target.value)}
                                    placeholder="Search archived jobs..."
                                    style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                                />
                            </div>
                            
                            {archivedJobsLoading && (
                                <div className="full-overlay" style={{ position: 'relative', minHeight: '200px' }}>
                                    <div className="spinner" style={{ width: '40px', height: '40px', borderWidth: '4px' }} />
                                    <p style={{fontSize:'1rem',fontWeight:'600',margin:'10px 0 0'}}>Loading archived jobs...</p>
                                </div>
                            )}
                            
                            {!archivedJobsLoading && archivedJobs.length === 0 && (
                                <div style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
                                    No archived jobs found
                                </div>
                            )}
                            
                            {!archivedJobsLoading && filteredArchivedJobs.length === 0 && archivedSearchTerm.trim() && (
                                <div className="error-box" style={{ marginTop: '10px' }}>
                                    No archived jobs match your search
                                </div>
                            )}
                            
                            {!archivedJobsLoading && filteredArchivedJobs.length > 0 && (
                                <ul className="project-search-list" style={{ position: 'relative', maxHeight: '400px', overflowY: 'auto' }}>
                                    {filteredArchivedJobs.map(job => (
                                        <li key={job.id} style={{ padding: '12px 15px' }}>
                                            <div className="archived-job-item">
                                                <div className="archived-job-info">
                                                    <span className="archived-job-name">{job.name}</span>
                                                    <span className="archived-job-meta">
                                                        {job.workspaceName} → {job.projectName}
                                                        {job.managerId && ` • Manager ID: ${job.managerId}`}
                                                        {job.jobPriority && ` • Priority: ${job.jobPriority}`}
                                                    </span>
                                                </div>
                                                <button
                                                    className="activate-button"
                                                    onClick={() => handleActivateClick(job)}
                                                    disabled={activatingJobId === job.id}
                                                >
                                                    {activatingJobId === job.id ? 'Activating...' : 'Activate'}
                                                </button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    )}
                </>
            )}
            
            {/* Add Job Modal (unchanged) */}
            <Modal isOpen={isAddJobOpen} onClose={closeAddModal} title="Add Job" customClass="modal-md">
                <div ref={modalContentRef} style={{ padding: '20px', position: 'relative' }}>
                    <div ref={addTopRef}></div>
                    {(isAdding || projectsLoading || usersLoading) && (
                        <div className="full-overlay">
                            <div className="spinner" />
                            <p style={{fontSize:'1.2rem',fontWeight:'600',margin:0}}>
                                {projectsLoading ? 'Loading projects...' : usersLoading ? 'Loading users...' : activeTab === 'bulk' ? `Adding ${parsedJobs.length} job${parsedJobs.length > 1 ? 's' : ''}...` : 'Adding job...'}
                            </p>
                        </div>
                    )}
                    <div style={{ opacity: isAdding ? 0.4 : 1, pointerEvents: isAdding ? 'none' : 'all' }}>
                        <div ref={errorRef} style={{marginBottom:'15px'}}>
                            {errorMessages.length > 0 && (
                                <div className="error-message">
                                    <ul style={{color:'#d32f2f',margin:'8px 0'}}>
                                        {errorMessages.map((msg,i) => <li key={i}>{msg}</li>)}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="tab-container" style={{marginBottom:'20px'}}>
                            <button className={`tab-button ${activeTab==='single'?'active':''}`} onClick={()=>setActiveTab('single')}>
                                Single Add
                            </button>
                            {isAdmin && (
                                <button className={`tab-button ${activeTab==='bulk'?'active':''}`} onClick={()=>setActiveTab('bulk')}>
                                    Bulk Add
                                </button>
                            )}
                        </div>
                        {activeTab === 'single' && (
                            <div className="form-container">
                                <div className="form-group full-width">
                                    <label>Project Search:</label>
                                    <div className="search-wrapper">
                                        <input
                                            type="text"
                                            value={singleProjectSearchTerm}
                                            onChange={handleSingleSearchChange}
                                            placeholder="Search projects..."
                                            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                                        />
                                        {singleProjectLoading && (
                                            <div className="dropdown-message">
                                                Loading...
                                            </div>
                                        )}
                                        {!singleProjectLoading && singleProjectSearchTerm.trim() && singleSearchedProjects.length === 0 && (
                                            <div className="dropdown-message error-box">
                                                No projects match your search
                                            </div>
                                        )}
                                        {!singleProjectLoading && singleSearchedProjects.length > 0 && (
                                            <ul className="project-search-list">
                                                {singleSearchedProjects.map(p => (
                                                    <li
                                                        key={p.id}
                                                        onClick={() => {
                                                            setSingleSelectedProject(p.id);
                                                            setSingleProjectSearchTerm('');
                                                            setSingleSearchedProjects([]);
                                                            fetchProjectJobs(p.id);
                                                        }}
                                                    >
                                                        {p.fullPath}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Project:</label>
                                    {modalProjectError ? (
                                        <div className="error-box">
                                            Failed to load projects
                                        </div>
                                    ) : activeProjects.length === 0 ? (
                                        <div className="error-box">
                                            No projects available
                                        </div>
                                    ) : (
                                        <select
                                            value={singleSelectedProject}
                                            onChange={(e) => {
                                                setSingleSelectedProject(e.target.value);
                                                fetchProjectJobs(e.target.value);
                                            }}
                                        >
                                            <option value="">Select Project</option>
                                            {activeProjects.map(p => (
                                                <option key={p.id} value={p.id}>{p.name}</option>
                                            ))}
                                        </select>
                                    )}
                                </div>
                                
                                {/* Modified Job Name Section with Dropdown */}
                                <div className="form-group">
                                    <label>Job Name:</label>
                                    <div className="job-name-search-wrapper">
                                        <input
                                            type="text"
                                            value={newJobName}
                                            onChange={(e) => {
                                                setNewJobName(e.target.value);
                                                setJobNameSearch(e.target.value);
                                                setShowJobDropdown(true);
                                            }}
                                            onFocus={() => setShowJobDropdown(true)}
                                            placeholder="Enter job name or click to see existing jobs"
                                            autoComplete="off"
                                            style={{ width: '100%' }}
                                        />
                                        
                                        {showJobDropdown && loadingProjectJobs && (
                                            <div className="dropdown-message" style={{ marginTop: '2px' }}>
                                                Loading jobs...
                                            </div>
                                        )}
                                        
                                        {showJobDropdown && !loadingProjectJobs && projectJobs.length > 0 && (
                                            <ul className="project-search-list" style={{ marginTop: '2px', maxHeight: '150px', overflowY: 'auto' }}>
                                                {projectJobs
                                                    .filter(job => 
                                                        job.jobName.toLowerCase().includes(jobNameSearch.toLowerCase())
                                                    )
                                                    .map(job => (
                                                        <li
                                                            key={job.jobId}
                                                            onClick={() => {
                                                                setNewJobName(job.jobName);
                                                                setShowJobDropdown(false);
                                                            }}
                                                            style={{ 
                                                                cursor: 'pointer', 
                                                                padding: '8px 12px',
                                                                transition: 'background-color 0.2s'
                                                            }}
                                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                                                            onMouseLeave={(e) => e.target.style.backgroundColor = ''}
                                                        >
                                                            {job.jobName}
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        )}
                                        
                                        {showJobDropdown && !loadingProjectJobs && projectJobs.length === 0 && singleSelectedProject && (
                                            <div className="dropdown-message" style={{ marginTop: '2px' }}>
                                                No existing jobs found for this project
                                            </div>
                                        )}
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label>Status:</label>
                                    <select value={newJobStatus} onChange={e => setNewJobStatus(parseInt(e.target.value))}>
                                        <option value={1}>Active</option>
                                        <option value={2}>Inactive</option>
                                        <option value={3}>Archive</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Type:</label>
                                    <input
                                        type="text"
                                        value={newJobType}
                                        onChange={(e) => setNewJobType(e.target.value)}
                                        placeholder="Enter job type"
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Priority:</label>
                                    <select value={newJobPriority ?? ''} onChange={e => setNewJobPriority(e.target.value === '' ? null : parseInt(e.target.value))}>
                                        <option value="">Select Priority</option>
                                        <option value={1}>1</option>
                                        <option value={2}>2</option>
                                        <option value={3}>3</option>
                                        <option value={4}>4</option>
                                        <option value={5}>5</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>Start Date:</label>
                                    <input
                                        type="date"
                                        value={newJobStartDate}
                                        onChange={(e) => setNewJobStartDate(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>End Date:</label>
                                    <input
                                        type="date"
                                        value={newJobEndDate}
                                        onChange={(e) => setNewJobEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Actual End Date:</label>
                                    <input
                                        type="date"
                                        value={newJobActualEndDate}
                                        onChange={(e) => setNewJobActualEndDate(e.target.value)}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Manager:</label>
                                    <select value={newJobManagerId ?? ''} onChange={e => setNewJobManagerId(e.target.value === '' ? null : parseInt(e.target.value))}>
                                        <option value="">Select Manager</option>
                                        {workspaceUsers.map(u => (
                                            <option key={u.userId} value={u.userId}>{`${u.fname} ${u.lname} (${u.email})`}</option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div className="form-group full-width">
                                    <label>Job Description:</label>
                                    <textarea
                                        value={newJobDescription}
                                        onChange={(e) => setNewJobDescription(e.target.value)}
                                        placeholder="Enter job description"
                                    />
                                </div>
                            </div>
                        )}
                        {activeTab === 'bulk' && (
                            <>
                                {!isReviewMode && (
                                    <>
                                        <div className="form-group">
                                            <label>Project Search:</label>
                                            <div className="search-wrapper">
                                                <input
                                                    type="text"
                                                    value={bulkProjectSearchTerm}
                                                    onChange={handleBulkSearchChange}
                                                    placeholder="Search projects..."
                                                    style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
                                                />
                                                {bulkProjectLoading && (
                                                    <div className="dropdown-message">
                                                        Loading...
                                                    </div>
                                                )}
                                                {!bulkProjectLoading && bulkProjectSearchTerm.trim() && bulkSearchedProjects.length === 0 && (
                                                    <div className="dropdown-message error-box">
                                                        No projects match your search
                                                    </div>
                                                )}
                                                {!bulkProjectLoading && bulkSearchedProjects.length > 0 && (
                                                    <ul className="project-search-list">
                                                        {bulkSearchedProjects.map(p => (
                                                            <li
                                                                key={p.id}
                                                                onClick={() => {
                                                                    setBulkSelectedProject(p.id);
                                                                    setBulkProjectSearchTerm('');
                                                                    setBulkSearchedProjects([]);
                                                                }}
                                                            >
                                                                {p.fullPath}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label>Project:</label>
                                            {modalProjectError ? (
                                                <div className="error-box">
                                                    Failed to load projects
                                                </div>
                                            ) : activeProjects.length === 0 ? (
                                                <div className="error-box">
                                                    No projects available
                                                </div>
                                            ) : (
                                                <select
                                                    value={bulkSelectedProject}
                                                    onChange={(e) => setBulkSelectedProject(e.target.value)}
                                                >
                                                    <option value="">Select Project</option>
                                                    {activeProjects.map(p => (
                                                        <option key={p.id} value={p.id}>{p.name}</option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <label>Paste from Excel (Name[Tab]Description per line):</label>
                                            <textarea
                                                value={pasteContent}
                                                onChange={handlePasteChange}
                                                placeholder="Job A Description A&#10;Job B Description B"
                                                className="modern-textarea"
                                                style={{minHeight:'180px'}}
                                            />
                                        </div>
                                        <div style={{textAlign:'center',margin:'20px 0'}}>
                                            <button onClick={handleReview} className="btn-primary" disabled={!pasteContent.trim()}>
                                                Review
                                            </button>
                                            <button onClick={handleClearPaste} className="btn-danger" style={{marginLeft:'10px'}}>
                                                Clear
                                            </button>
                                        </div>
                                    </>
                                )}
                                {isReviewMode && (
                                    <>
                                        <h4 style={{textAlign:'center',margin:'15px 0'}}>Review Jobs ({parsedJobs.length})</h4>
                                        <div ref={tableRef} style={{maxHeight:'320px',overflowY:'auto',border:'1px solid #ddd',borderRadius:'8px'}}>
                                            <table className="modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Description</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {parsedJobs.map((job, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    value={job.name}
                                                                    onChange={(e) => handleEditParsedJob(index, 'name', e.target.value)}
                                                                    className="modern-input"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    value={job.description}
                                                                    onChange={(e) => handleEditParsedJob(index, 'description', e.target.value)}
                                                                    className="modern-input"
                                                                />
                                                            </td>
                                                            <td>
                                                                <button onClick={() => handleDeleteRow(index)} className="icon-button danger">
                                                                    <i className="fas fa-trash"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{marginTop:'15px',textAlign:'center'}}>
                                            <button onClick={handleAddNewRow} className="icon-button secondary">
                                                Add Row
                                            </button>
                                            <button onClick={handleAddBulkJobs} className="btn-primary" style={{marginLeft:'12px'}}>
                                                Add All Jobs
                                            </button>
                                            <button onClick={() => setIsReviewMode(false)} className="btn-secondary" style={{marginLeft:'12px'}}>
                                                Back
                                            </button>
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                        <div className="modal-footer" style={{marginTop:'30px', gridColumn: 'span 2'}}>
                            {activeTab === 'single' && (
                                <button
                                    className="btn-primary"
                                    onClick={handleAddJob}
                                    disabled={!singleSelectedProject || !newJobName.trim() || isAdding}
                                >
                                    {isAdding ? 'Adding...' : 'OK'}
                                </button>
                            )}
                            {activeTab === 'bulk' && isReviewMode && (
                                <button
                                    className="btn-primary"
                                    onClick={handleAddBulkJobs}
                                    disabled={!bulkSelectedProject || parsedJobs.length === 0 || isAdding}
                                >
                                    {isAdding ? 'Adding...' : 'OK'}
                                </button>
                            )}
                            <button className="btn-close" onClick={closeAddModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            
            {/* Edit Job Modal */}
            <Modal isOpen={isEditJobOpen} onClose={closeEditModal} title="Edit Job" customClass="modal-sm">
                <div ref={editModalContentRef} className="settings-form" style={{ position: 'relative' }}>
                    <div ref={editTopRef}></div>
                    {(usersLoading || editLoading || isEditing) && (
                        <div className="full-overlay">
                            <div className="spinner" />
                            <p style={{fontSize:'1.2rem',fontWeight:'600',margin:0}}>{usersLoading ? 'Loading users...' : editLoading ? 'Loading job...' : 'Updating job...'}</p>
                        </div>
                    )}
                    <div ref={editErrorRef} style={{marginBottom:'15px', gridColumn: 'span 2'}}>
                        {editErrorMessages.length > 0 && (
                            <div className="error-message">
                                <ul style={{color:'#d32f2f',margin:'8px 0'}}>
                                    {editErrorMessages.map((msg,i) => <li key={i}>{msg}</li>)}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="form-container">
                        <div className="form-group">
                            <label>Project:</label>
                            <select value={selectedProject} disabled>
                                {allProjects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Job Name:</label>
                            <input value={newJobName} onChange={e => setNewJobName(e.target.value)} />
                        </div>
                       
                        <div className="form-group">
                            <label>Status:</label>
                            <select value={newJobStatus} onChange={e => setNewJobStatus(parseInt(e.target.value))}>
                                <option value={1}>Active</option>
                                <option value={2}>Inactive</option>
                                <option value={3}>Archive</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Type:</label>
                            <input
                                type="text"
                                value={newJobType}
                                onChange={(e) => setNewJobType(e.target.value)}
                                placeholder="Enter job type"
                            />
                        </div>
                        <div className="form-group">
                            <label>Priority:</label>
                            <select value={newJobPriority ?? ''} onChange={e => setNewJobPriority(e.target.value === '' ? null : parseInt(e.target.value))}>
                                <option value="">Select Priority</option>
                                <option value={1}>1</option>
                                <option value={2}>2</option>
                                <option value={3}>3</option>
                                <option value={4}>4</option>
                                <option value={5}>5</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                value={newJobStartDate}
                                onChange={(e) => setNewJobStartDate(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>End Date:</label>
                            <input
                                type="date"
                                value={newJobEndDate}
                                onChange={(e) => setNewJobEndDate(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Actual End Date:</label>
                            <input
                                type="date"
                                value={newJobActualEndDate}
                                onChange={(e) => setNewJobActualEndDate(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Manager:</label>
                            <select value={newJobManagerId ?? ''} onChange={e => setNewJobManagerId(e.target.value === '' ? null : parseInt(e.target.value))}>
                                <option value="">Select Manager</option>
                                {workspaceUsers.map(u => (
                                    <option key={u.userId} value={u.userId}>{`${u.fname} ${u.lname} (${u.email})`}</option>
                                ))}
                            </select>
                        </div>
                         <div className="form-group full-width">
                            <label>Description:</label>
                            <textarea value={newJobDescription} onChange={e => setNewJobDescription(e.target.value)} />
                        </div>
                    </div>
                    
                    <div className="modal-footer" style={{marginTop:'30px', gridColumn: 'span 2'}}>
                        <button className="btn-primary" onClick={handleEditJob} disabled={!newJobName.trim() || isEditing}>
                            {isEditing ? 'Updating...' : 'OK'}
                        </button>
                        <button className="btn-close" onClick={closeEditModal}>
                            Cancel
                        </button>
                    </div>              
                  
                </div>
            </Modal>
            <ConfirmationModal
                isOpen={showDeleteConfirm}
                onClose={() => {
                    setShowDeleteConfirm(false);
                    setDeleteError(null);
                }}
                onConfirm={handleDeleteJob}
                title="Delete Job"
                message={
                <>
                    Are you sure you want to delete <strong>"{newJobName}"</strong>?
                    {deleteError && (
                        <span style={{ 
                            display: 'block',
                            marginTop: '15px', 
                            padding: '10px', 
                            backgroundColor: '#fff5f5', 
                            border: '1px solid #dc3545', 
                            borderRadius: '6px',
                            color: '#dc3545',
                            fontSize: '13px'
                        }}>
                            <i className="fas fa-exclamation-circle" style={{ marginRight: '8px' }}></i>
                            {deleteError}
                        </span>
                    )}
                </>
            }
                confirmText={deletingJob ? "Deleting..." : "Delete"}
                cancelText="Cancel"
                isDanger={true}
            />
        </div>
    );
};

export default JobManagment;